import React from "react";
import classNames from "classnames";

export interface CrumbProps {
  label: string;
  /** Use "light" on dark / photo backgrounds (e.g. the video hero). */
  variant?: "brand" | "light";
  className?: string;
}

/**
 * Small uppercase eyebrow label shown above section titles.
 * The "brand" variant is plain tinted text; the "light" variant keeps a pill
 * (bordered, slightly transparent fill) for legibility on dark / photo backgrounds.
 */
const Crumb: React.FC<CrumbProps> = ({ label, variant = "brand", className }) => (
  <span
    className={classNames(
      "inline-block text-sm font-semibold uppercase tracking-wider",
      {
        "text-SP6": variant === "brand",
        // rounded-full border border-White/60 bg-White/10 px-5 py-2
        "text-White": variant === "light",
      },
      className,
    )}
  >
    {label}
  </span>
);

export default Crumb;
